import Rest from '../Rest'

export default class CityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/cities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findAllByFederationUnity(federalUnitId) {
    return this.get(`/federal_unit/${federalUnitId}`).then(data => {
      return data
    })
  }
}
